import { Box, Button, Typography } from '@mui/material'
import { calculateAge } from '../../utils/Common'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'

interface RecentClientProps {
  clientId: string | undefined
}

const clientsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.clients,
)
const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)

const RecentClientComponent: React.FC<RecentClientProps> = ({ clientId }) => {
  const clients = useSelector(clientsSelector)
  const projects = useSelector(projectsSelector)
  const client = clients.find((client) => client.id === clientId)
  const clientProjects = projects.filter(
    (project) => project.client_id === client?.id,
  )

  return (
    <Button
      disableRipple
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textTransform: 'none',
        p: 0,
        width: '100%',
        '&:hover': {
          background: 'transparent',
        },
      }}
    >
      <Box width='100%' display='flex' flexDirection='column' gap='1rem'>
        <Box display='flex' alignItems='center'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.94rem',

              color: '#04002E',
            }}
          >
            {client?.name}
          </Typography>
        </Box>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',

              color: '#04002E',
            }}
          >
            {clientProjects.length} Projects
          </Typography>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.58rem',

              color: '#04002E',
            }}
          >
            Updated: {calculateAge(client?.updatedAt ?? Date.now().toString())}
          </Typography>
        </Box>
      </Box>
    </Button>
  )
}

export default RecentClientComponent
